//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all users.
 * @param search (optional) The query to search the users
 */
export function getUsers(search?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.UserDto[]> {
    let url_ = getBaseUrl() + "/api/users?";
    if (search !== undefined && search !== null)
        url_ += "search=" + encodeURIComponent("" + search) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetUsers,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetUsers?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetUsers(_response);
    });
}

function processGetUsers(response: AxiosResponse): Promise<Types.UserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initUserDto(item)
              );
            }
        return Promise.resolve<Types.UserDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserDto[]>(null as any);
}

/**
 * Changes password by a user.
 * @param dto The dto contains old and new passwords.
 */
export function changePassword(dto: Types.ChangePasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeChangePasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangePassword,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigChangePassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangePassword(_response);
    });
}

function processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Creates a user by admin of some Tenant.
Automatically adds the user to a Subtenant.
 * @param dto Request parameter
 */
export function createUser(dto: Types.CreateUserByAdminDto, config?: AxiosRequestConfig | undefined): Promise<Types.UserDto> {
    let url_ = getBaseUrl() + "/api/users";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateUserByAdminDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateUser,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateUser?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateUser(_response);
    });
}

function processCreateUser(response: AxiosResponse): Promise<Types.UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUserDto(resultData200);
        return Promise.resolve<Types.UserDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initUserDto(resultData201);
        return Promise.resolve<Types.UserDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserDto>(null as any);
}

/**
 * Changes password for a user.
 * @param id The user id.
 * @param dto The dto contains password.
 */
export function changePasswordByAdmin(id: string, dto: Types.CreatePasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}/password";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreatePasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangePasswordByAdmin,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigChangePasswordByAdmin?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangePasswordByAdmin(_response);
    });
}

function processChangePasswordByAdmin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Allows user to reset their password using single-use password reset token issued by the backend.
 */
export function resetPassword(dto: Types.ResetPasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/reset-password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeResetPasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetPassword,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResetPassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetPassword(_response);
    });
}

function processResetPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Edits a user. This should only be accessible by ADMINs, since it changes roles and Subtenants
 * @param id The user id.
 * @param dto Request parameter.
 */
export function editUser(id: string, dto: Types.UpdateUserDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateUserDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditUser,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditUser?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditUser(_response);
    });
}

function processEditUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes a user.
 * @param id The user id.
 */
export function removeUser(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveUser,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveUser?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveUser(_response);
    });
}

function processRemoveUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets a user by id.
 * @param id The user id.
 */
export function getUser(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.UserDto> {
    let url_ = getBaseUrl() + "/api/users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetUser,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetUser?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetUser(_response);
    });
}

function processGetUser(response: AxiosResponse): Promise<Types.UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUserDto(resultData200);
        return Promise.resolve<Types.UserDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserDto>(null as any);
}

/**
 * Locks a user.
 * @param id The user id.
 */
export function lockUser(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}/lock";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigLockUser,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigLockUser?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processLockUser(_response);
    });
}

function processLockUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Unlocks a user.
 * @param id The user id.
 */
export function unlockUser(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{id}/unlock";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUnlockUser,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUnlockUser?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUnlockUser(_response);
    });
}

function processUnlockUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets permissions for the current user
 */
export function getCurrentUserPermissions(config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/users/current/permissions";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCurrentUserPermissions,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCurrentUserPermissions?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCurrentUserPermissions(_response);
    });
}

function processGetCurrentUserPermissions(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}
let _requestConfigGetUsers: Partial<AxiosRequestConfig> | null;
export function getGetUsersRequestConfig() {
  return _requestConfigGetUsers;
}
export function setGetUsersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetUsers = value;
}
export function patchGetUsersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetUsers = patch(_requestConfigGetUsers ?? {});
}

let _requestConfigChangePassword: Partial<AxiosRequestConfig> | null;
export function getChangePasswordRequestConfig() {
  return _requestConfigChangePassword;
}
export function setChangePasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangePassword = value;
}
export function patchChangePasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangePassword = patch(_requestConfigChangePassword ?? {});
}

let _requestConfigCreateUser: Partial<AxiosRequestConfig> | null;
export function getCreateUserRequestConfig() {
  return _requestConfigCreateUser;
}
export function setCreateUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateUser = value;
}
export function patchCreateUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateUser = patch(_requestConfigCreateUser ?? {});
}

let _requestConfigChangePasswordByAdmin: Partial<AxiosRequestConfig> | null;
export function getChangePasswordByAdminRequestConfig() {
  return _requestConfigChangePasswordByAdmin;
}
export function setChangePasswordByAdminRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangePasswordByAdmin = value;
}
export function patchChangePasswordByAdminRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangePasswordByAdmin = patch(_requestConfigChangePasswordByAdmin ?? {});
}

let _requestConfigResetPassword: Partial<AxiosRequestConfig> | null;
export function getResetPasswordRequestConfig() {
  return _requestConfigResetPassword;
}
export function setResetPasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = value;
}
export function patchResetPasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = patch(_requestConfigResetPassword ?? {});
}

let _requestConfigEditUser: Partial<AxiosRequestConfig> | null;
export function getEditUserRequestConfig() {
  return _requestConfigEditUser;
}
export function setEditUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditUser = value;
}
export function patchEditUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditUser = patch(_requestConfigEditUser ?? {});
}

let _requestConfigRemoveUser: Partial<AxiosRequestConfig> | null;
export function getRemoveUserRequestConfig() {
  return _requestConfigRemoveUser;
}
export function setRemoveUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveUser = value;
}
export function patchRemoveUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveUser = patch(_requestConfigRemoveUser ?? {});
}

let _requestConfigGetUser: Partial<AxiosRequestConfig> | null;
export function getGetUserRequestConfig() {
  return _requestConfigGetUser;
}
export function setGetUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetUser = value;
}
export function patchGetUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetUser = patch(_requestConfigGetUser ?? {});
}

let _requestConfigLockUser: Partial<AxiosRequestConfig> | null;
export function getLockUserRequestConfig() {
  return _requestConfigLockUser;
}
export function setLockUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigLockUser = value;
}
export function patchLockUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigLockUser = patch(_requestConfigLockUser ?? {});
}

let _requestConfigUnlockUser: Partial<AxiosRequestConfig> | null;
export function getUnlockUserRequestConfig() {
  return _requestConfigUnlockUser;
}
export function setUnlockUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUnlockUser = value;
}
export function patchUnlockUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUnlockUser = patch(_requestConfigUnlockUser ?? {});
}

let _requestConfigGetCurrentUserPermissions: Partial<AxiosRequestConfig> | null;
export function getGetCurrentUserPermissionsRequestConfig() {
  return _requestConfigGetCurrentUserPermissions;
}
export function setGetCurrentUserPermissionsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCurrentUserPermissions = value;
}
export function patchGetCurrentUserPermissionsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCurrentUserPermissions = patch(_requestConfigGetCurrentUserPermissions ?? {});
}